export const querySingletonDoc = (type: string, id: string) =>
  `*[_type in ["${type}"] && _id == "${id}"][0]`;
